import Switch from "react-switch";
import React, { useState } from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import { useCartorio } from "../../Hooks/cartorio";
import {
  IFuncionarioCartorio,
  useFuncionarioCartorio,
} from "../../Hooks/funcionarioCartorio";
import {
  IFuncionarioPrefeitura,
  useFuncionarioPrefeitura,
} from "../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../Hooks/usePrefeitura";
import api from "../../Services/api";
import { limpaMaskCelular } from "../../Services/limpaMaskCelular";
import { limpa_cpf_cnpj } from "../../Services/limpa_cpf_cnpj";
import { validaCelular } from "../../Services/validaCelular";
import { validateEmail } from "../../Services/validaEmail";
import { validateCPF } from "../../Services/validateCPF";
import theme from "../../Styles/theme";
import { DarkButton } from "../DarkButton";
import { Alert } from "../Error/Alert";
import { ModalLoader } from "../ModalLoader";
import { PerfilInput } from "../PerfilInput";
import { Container, DivX, HandleInput, HandleButton } from "./styles";
import { AtivoSpan, Label } from "../EditFuncionarioModal/styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
}

export function AddFuncionarioModal({ open, onClose }: Props) {
  const { cartorio, cartorioIsLogged, checarToken } = useCartorio();
  const {
    prefeitura,
    prefeituraIsLogged,
    checarTokenPrefeitura,
  } = usePrefeitura();
  const { addCartoroFuncionarioCartorio } = useFuncionarioCartorio();
  const { addCartoroFuncionarioPrefeitura } = useFuncionarioPrefeitura();
  const [NOME, setNome] = useState("");
  const [CPF, setCPF] = useState("");
  const [EMAIL, setEMAIL] = useState("");
  const [WHATS, setWHATS] = useState("");
  const [FONE, setFONE] = useState("");
  const [SENHA, setSENHA] = useState("");
  const [AVALIAR, setAVALIAR] = useState("S" as "S" | "N");
  const [error, setError] = useState({ message: "", title: "" } as {
    message: string;
    title: string;
  });

  const [loading, setLoading] = useState(false);
  function validaForm() {
    if (!validateEmail(EMAIL)) {
      setError({
        message: `O endereço de email digitado não é válido!`,
        title: "Email Inválido!",
      });
      return false;
    }
    if (NOME.trim().length == 0) {
      setError({
        message: `Não é possível adicionar um funcionário com nome vázio!`,
        title: "Nome Inválido!",
      });
      return false;
    }

    if (!validateCPF(limpa_cpf_cnpj(CPF))) {
      setError({
        message: `O CPF digitado não é válido!`,
        title: "CPF Inválido!",
      });
      return false;
    }

    if (Number(limpaMaskCelular(WHATS)) > 0) {
      if (!validaCelular(limpaMaskCelular(WHATS))) {
        setError({
          message: `O número de celular não é válido!`,
          title: "Celular Inválido!",
        });
        return false;
      }
    }

    if (Number(limpaMaskCelular(FONE)) > 0) {
      if (!validaCelular(limpaMaskCelular(FONE))) {
        setError({
          message: `O número de telefone não é válido!`,
          title: "Telefone Inválido!",
        });
        return false;
      }
    }

    if (SENHA.length == 0) {
      setError({
        message: `Você deve preencher o campo com uma senha temporária para criar um novo funcionário!`,
        title: "Senha Inválida!",
      });
      return false;
    }

    return true;
  }

  async function post() {
    if (validaForm()) {
      try {
        setLoading(true);
        if (cartorioIsLogged) {
          await checarToken();
          const funcionarios = await api.get<IFuncionarioCartorio[]>(
            `/funcionario-cartorio/por-cpf/${limpa_cpf_cnpj(CPF)}`
          );

          if (funcionarios.data.length > 0) {
            for (let index = 0; index < funcionarios.data.length; index++) {
              const item = funcionarios.data[index];
              if (item.CARTORIO_ID == cartorio.ID) {
                setError({
                  title: "Não foi possível cadastrar um novo usuario!",
                  message: "Já existe um funcionário com este CPF!",
                });
                return;
              }
            }
          }

          const { data } = await api.post(`/funcionario-cartorio/`, {
            NOME,
            CPF: limpa_cpf_cnpj(CPF),
            EMAIL,
            WHATS: limpaMaskCelular(WHATS),
            SENHA,
            FONE: limpaMaskCelular(FONE),
            ATIVO: "A",
          });
          addCartoroFuncionarioCartorio(data.result);
        } else if (prefeituraIsLogged) {
          await checarTokenPrefeitura();

          const funcionarios = await api.get<IFuncionarioPrefeitura[]>(
            `/funcionario-prefeitura/por-cpf/${limpa_cpf_cnpj(CPF)}`
          );

          if (funcionarios.data.length > 0) {
            for (let index = 0; index < funcionarios.data.length; index++) {
              const item = funcionarios.data[index];
              if (item.PREFEITURA_ID == prefeitura.ID) {
                setError({
                  title: "Não foi possível cadastrar um novo usuario!",
                  message: "Já existe um funcionário com este CPF!",
                });
                return;
              }
            }
          }

          const { data } = await api.post(`/funcionario-prefeitura/`, {
            NOME,
            CPF: limpa_cpf_cnpj(CPF),
            EMAIL,
            WHATS: limpaMaskCelular(WHATS),
            SENHA,
            FONE: limpaMaskCelular(FONE),
            ATIVO: "A",

            AVALIAR,
          });
          addCartoroFuncionarioPrefeitura(data.result);
        }

        onClose();
      } catch (err) {
        setError({
          title: "Erro durante inclusão de funcionário!",
          message: `Não foi possível incluir ${NOME}, cheque se os campos estão preenchidos corretamente ou tente novamente mais tarde!`,
        });
      } finally {
        setLoading(false);
      }
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={() => {}} style={customStyles}>
      <Container>
        <DivX>
          <X
            onClick={onClose}
            style={{ cursor: "pointer" }}
            color={theme.colors.dark}
            size={"max(0.6vw +  6px)"}
          />
        </DivX>
        <HandleInput>
          <PerfilInput
            execute={(str) => {
              setNome(str);
            }}
            value={NOME}
            title={"NOME"}
            ativo={true}
            disabled={false}
          />
          <PerfilInput
            execute={(str) => {
              setEMAIL(str);
            }}
            value={EMAIL}
            title={"EMAIL"}
            ativo={true}
            disabled={false}
          />
        </HandleInput>

        <HandleInput>
          <PerfilInput
            execute={(str) => {
              setFONE(str);
            }}
            value={FONE}
            title={"FONE"}
            ativo={true}
            disabled={false}
          />
          <PerfilInput
            execute={(str) => {
              setWHATS(str);
            }}
            value={WHATS}
            title={"CELULAR"}
            ativo={true}
            disabled={false}
          />
        </HandleInput>

        <HandleInput>
          <PerfilInput
            execute={(str) => {
              setCPF(str);
            }}
            value={CPF}
            title={"CPF"}
            ativo={true}
            disabled={false}
          />
          <PerfilInput
            execute={(str) => {
              setSENHA(str);
            }}
            value={SENHA}
            title={"SENHA"}
            ativo={true}
            disabled={false}
          />
        </HandleInput>
        {cartorioIsLogged ? (
          <></>
        ) : (
          <Label>
            <AtivoSpan>
              {AVALIAR ? "Avaliador" : "Avaliador"}
            </AtivoSpan>
            <Switch
              onChange={() => {
                setAVALIAR((prev) => (prev == "S" ? "N" : "S"));
              }}
              checked={AVALIAR == "S"}
              color={theme.colors.primary}
              offColor={theme.colors.darkGrey}
              onColor={theme.colors.primary}
            />
          </Label>
        )}

        <HandleButton>
          <DarkButton title="CONFIRMAR" execute={post} />
        </HandleButton>

        <Alert
          open={error.message.length > 0}
          onClose={() => setError({ message: "", title: "" })}
          message={error.message}
          title={error.title}
        />
        <ModalLoader loading={loading} />
      </Container>
    </Modal>
  );
}
